var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"range-picker"},[_c('div',{staticClass:"range-picker__wrapper"},[_c('div',{staticClass:"mb-4 range-picker__title"},[_vm._v("Select Period")]),_c('date-range-picker',{key:_vm.pickerKey,ref:"rangePicker",class:{ 'prev-arrow-hidden': _vm.isPrevMonthArrowHidden },attrs:{"date-format":_vm.dateFormat,"single-date-picker":_vm.singleDatePicker,"minDate":_vm.minDate,"locale-data":{
				monthNames: [
					'January',
					'February',
					'March',
					'April',
					'May',
					'June',
					'July',
					'August',
					'September',
					'October',
					'November',
					'December'
				],
				daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
				format: 'M/D/YYYY'
			}},on:{"select":_vm.select,"toggle":_vm.togglePicker,"change-month":_vm.onMonthChanged},scopedSlots:_vm._u([{key:"input",fn:function(picker){return [_c('icon-svg',{attrs:{"icon":"ic_calendar","fill":"#816CC2"}}),(
						!_vm.state.dateRange.endDate && !_vm.state.dateRange.startDate && !_vm.isOpen
					)?_c('div',{staticClass:"range-picker__placeholder"},[_vm._v(" All Dates ")]):[_c('div',{staticClass:"range-picker__start",class:{
							'range-picker__start--grey': !_vm.getFormattedDate(picker.startDate)
						}},[_vm._v(" "+_vm._s(_vm.getFormattedDate(picker.startDate) || 'mm/dd/yyyy')+" ")]),_c('icon-svg',{attrs:{"icon":"arrow_right"}}),_c('div',{staticClass:"range-picker__end",class:{
							'range-picker__end--grey':
								_vm.temporaryStart || !_vm.state.dateRange.endDate
						}},[_vm._v(" "+_vm._s((!_vm.temporaryStart && _vm.state.dateRange.endDate) || 'mm/dd/yyyy')+" ")])],_c('icon-svg',{staticClass:"range-picker__arrow-down",class:{ 'range-picker__arrow-down--rotate': _vm.isOpen },attrs:{"icon":"arrow_down"}})]}}]),model:{value:(_vm.state.dateRange),callback:function ($$v) {_vm.$set(_vm.state, "dateRange", $$v)},expression:"state.dateRange"}})],1),_c('div',{staticClass:"range-picker__view-all bold",on:{"click":_vm.viewAll}},[_vm._v(" View All ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }